import React from 'react'
import classNames from 'classnames'
import { When } from 'react-if'
import { ParagraphSM, TitleXS } from '@/atoms/Text'
import { useIsDarkMode } from '@/contexts/ThemeContext'

interface SearchHitTextBlockProps {
  label: React.ReactElement
  subLabel?: React.ReactElement
  caption: React.ReactElement
}

export const SearchHitTextBlock: React.FC<SearchHitTextBlockProps> = ({ label, subLabel, caption }) => {
  const isDarkMode = useIsDarkMode()

  return (
    <div className="h-fit">
      <TitleXS weight="semibold">{label}</TitleXS>

      <When condition={!!subLabel}>
        <ParagraphSM
          weight="medium"
          className={classNames('mt-1 line-clamp-3 leading-tight', { 'text-core-gray-100': isDarkMode })}
        >
          {subLabel}
        </ParagraphSM>
      </When>

      <ParagraphSM
        weight="normal"
        className={classNames(
          'mt-1 line-clamp-1 leading-tight',
          isDarkMode ? 'text-core-gray-500' : 'text-core-gray-600',
        )}
      >
        {caption}
      </ParagraphSM>
    </div>
  )
}
